import SqPopoverComponent from './sq-popover';
export default SqPopoverComponent.extend({
  attributeBindings: ['style']
});